// Режим папок редактора (задача #6536).
// window.EDITOR_FOLDER_MODE прокидывается ядром на /foquz и /foquz/users:
//   'simple'   — старое поведение, без создания папок верхнего уровня и без шаринга.
//   'advanced' — редакторы могут создавать папки верхнего уровня и делиться ими (гостевой доступ).
// window.GUEST_FOLDERS — список id корневых папок, к которым у текущего пользователя есть
// гостевой доступ (пустой в режиме simple). Папка считается гостевой, если она является одним
// из этих корней или находится где-либо внутри одного из них.

export const EDITOR_FOLDER_MODE = window.EDITOR_FOLDER_MODE || "simple";
export const IS_ADVANCED_FOLDER_MODE = EDITOR_FOLDER_MODE === "advanced";

const rawGuestFolders = Array.isArray(window.GUEST_FOLDERS)
  ? window.GUEST_FOLDERS
  : [];

// приводим к строкам — id папок в одних ответах приходят числами, а в других
// строками (например, useFoldersList приводит их к строкам).
export const GUEST_FOLDER_ROOT_IDS = rawGuestFolders.map((id) => String(id));

const guestRootSet = new Set(GUEST_FOLDER_ROOT_IDS);

export function isGuestRootFolder(id) {
  return guestRootSet.has(String(id));
}

// Помечает в плоском списке useFoldersList (родитель идёт раньше детей)
// гостевые папки и их поддеревья как inactive — создавать папки внутри
// папки с гостевым доступом нельзя (задача #6537, п.10).
export function markGuestFoldersInactive(items) {
  if (!guestRootSet.size) return items;

  const guestIds = new Set();
  return items.map((item) => {
    const id = String(item.id);
    const isGuest =
      guestRootSet.has(id) ||
      (item.parent != null && guestIds.has(String(item.parent)));
    if (!isGuest) return item;
    guestIds.add(id);
    return { ...item, inactive: true };
  });
}

// Помечает в дереве useFoldersList (элементы с children) гостевые папки и их
// поддеревья как active — внутри гостевой папки и её вложенных папок редактор
// может создавать опросы (задача #6537, п.13-15). Бэкенд ставит им inactive,
// потому что гостевой доступ (EditorFolderShare) не учитывается в EditorFolder.
export function markGuestFoldersActiveInTree(folders, parentGuest = false) {
  if (!guestRootSet.size) return folders;

  return folders.map((folder) => {
    const isGuest = parentGuest || guestRootSet.has(String(folder.id));
    const children = markGuestFoldersActiveInTree(folder.children || [], isGuest);
    if (!isGuest) return { ...folder, children };
    return { ...folder, children, inactive: false };
  });
}

const currentUser = window.CURRENT_USER || {};
export const IS_EDITOR = !!currentUser.editor;
export const IS_ADMIN = !!currentUser.admin;
